(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.index = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var rg4js = window.rg4js;
  var parseUser = exports.parseUser = function parseUser(me) {
    return {
      identifier: me.primaryEmail,
      isAnonymous: false,
      fullName: me.firstName + ' ' + me.lastName,
      firstName: me.firstName,
      email: me.primaryEmail,
      uuid: me.id
    };
  };
  var RaygunUser = exports.RaygunUser = function RaygunUser(_ref) {
    var me = _ref.me,
      authReady = _ref.authReady;
    if (!rg4js) throw new Error('Missing reference to rg4js');
    if (authReady && me) {
      rg4js('setUser', parseUser(me));
    }
    return null;
  };
  exports.default = RaygunUser;
});